export const toGPTMessage = (
  prompt: string,
  conversationId: string | null,
  mode: string,
) => {
  const email = localStorage.getItem("email");

  const message = {
    action: "sendmsgtest",
    message: prompt,
    email,
    conversationId,
    mode,
  };
  return JSON.stringify(message);
};
